module.exports = __webpack_public_path__ + "static/media/past_1.825ed190.jpg";